import React from "react";
import { Modal, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, ModalProps, Text } from "@chakra-ui/react";
import { colours } from "@/utils/themeUtils";

interface Props extends Omit<ModalProps, "isOpen" | "onClose"> {
	isOpen: boolean;
	onClose: () => void;
	title: string;
	/**
	 * This is expecting to take <ModalHeader>, <ModalBody> and/or <ModalFooter> as children.
	 */
	children: React.ReactNode;
	dataTestId?: string;
	minHeight?: string;
	maxHeight?: string;
}

/**
 * A standard implementation of the Chakra UI modal to promote consistency. Keeps all the modal styles in a single component to reduce repetition.
 */
export function ClasswizeModal(props: Props): JSX.Element {
	return (
		<Modal data-testid={props.dataTestId} {...props} isOpen={props.isOpen} onClose={props.onClose} isCentered>
			<ModalOverlay />
			<ModalContent data-testid={`${props.dataTestId}-content`} p={3} minHeight={props.minHeight} maxHeight={props.maxHeight}>
				<ModalHeader>
					<Text fontSize={"20px"} color={colours.text.body} fontWeight={500} fontFamily={"Poppins"}>
						{props.title}
					</Text>
				</ModalHeader>
				<ModalCloseButton mt={2} mr={1} size={"lg"} data-testid="modal-close-btn" />
				{/* props.children is expected to be <ModalHeader>, <ModalBody> and/or <ModalFooter> */}
				{props.children}
			</ModalContent>
		</Modal>
	);
}
